import { ToggleButton } from "../../components/buttons/ToggleButton";
import { ExpandingTooltipReturn } from "../../components/hooks/useAdvancedTooltip";

export { HardcodeButton };

type Props = {
  isDefault: boolean;
  onClick: () => void;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};
/**
 * Button exposes functionality to toggle between F_DEFAULT and F_REGEX for ColumnEditors
 * @param props
 */
const HardcodeButton = ({ isDefault, onClick, tProps }: Props) => {
  return (
    <ToggleButton
      active={isDefault}
      tProps={tProps}
      className={isDefault ? "" : "white"}
      onClick={onClick}
    >
      H
    </ToggleButton>
  );
};
